/**
 * Ventilation parameter value in range enum
 */
export enum VentilationParameterValueInRange {
    HIGH = 'high',
    LOW = 'low',
    IN_RANGE = 'in_range',
}
